<template>
  <div class="section">
    <!-- 建议过夜--->
    <div class="advice-info" v-if="isTeamReport == false">
      <div class="advice-info-title">
        <img :src="images.icR" style="width: 2.5%" /><span>面试建议</span>
      </div>
      <div style="padding-left: 30px; padding-top: 20px">
        问题仅供参考，面试官可结合现场实况进行灵活调整。
      </div>
      <div
        v-for="(item, index) in this.msjy"
        :key="index"
        style="padding: 7px 30px 0 30px"
      >
        <div>
          <img :src="images.ic" style="height: auto; width: 0.7%" />
          {{ item.name }}
        </div>
        <div style="margin-left:-10px;font-size:14px" v-html="item.define"></div>
      </div>
      <div
        v-for="(item, index) in this.adviceNoTeam"
        :key="index"
        style="padding: 7px 30px 0 30px"
      >
        <div>
          <img :src="images.ic" style="height: auto; width: 0.7%" />
          {{ item.name }}
        </div>
        <div style="margin-left:-10px;font-size:14px" v-html="item.define"></div>
      </div>
    </div>

    <div class="result-title" v-if="isTeamReport == true">
      <div
        v-for="(item, index) in this.advice"
        :key="index"
        style="padding: 5px 0 0 30px"
      >
        <div>
          <img :src="images.ic" style="height: auto; width: 0.7%" />
          {{ item.name }}
        </div>
        <div style="margin-left:-10px;font-size:14px" v-html="item.define"></div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: ["advice", "isTeamReport", "adviceNoTeam", "msjy"],
  data() {
    return {
      images: {
        ic: require("../../../assets/images/all/ic.png"),
        icR: require("../../../assets/images/all/icR.png"),
      },
    };
  },
  mounted() {},
  watch: {},
  methods: {},
};
</script>

<style lang="scss" scoped>
.section {
  page-break-before: always;
  page-break-after: always;
  page-break-inside: avoid;
  background-size: cover;
  padding-top: 20px;
  //   background-image: url("../../../assets/images/all/bg55.png");
  height: 1124px;
  overflow: hidden;
  .advice-info {
    margin-top: 50px;

    width: 100%;
    height: 950px;
    background-color: #f5f8fd;
    .advice-info-title {
      text-align: center;
      padding-top: 20px;
      font-weight: bold;
      font-size: 25px;
    }
  }
  .title-info {
    padding: 270px 0 0 0;
    text-align: center;
  }
  .result-title {
    padding-top: 20px;
    padding-bottom: 20px;
    width: 100%;
    height: auto;
    background-color: #f5f8fd;
  }
  .result-content {
    color: white;
    font-size: 30px;
    font-weight: bold;
    margin-top: 21px;
    margin-left: -10px;
    line-height: 30px;
  }
}
</style>



// WEBPACK FOOTER //
// src/views/report/four/pageAdvice.vue